module.exports = __webpack_public_path__ + "img/Freespin_l3.9e511f4b.png";